import { Area } from 'editor/src/store/design/operation/getNewElementDisplay';
import { Spread } from 'editor/src/store/design/types';

import { createFreeSpotFinder, SheetRect } from 'editor/src/util/gangSheet/findFreeSpot';
import { RollLengthBounds } from 'editor/src/util/gangSheet/rollingSheetLength';

import getSheetArtworkRects from './getSheetArtworkRects';

type RollingSheetSpot = { x: number; y: number; rect: SheetRect };

// Places upright pieces of artwork on a rolling gang sheet one after another: each goes
// into the first gap, top to bottom, that keeps gapMm clear of everything already there
// and of the pieces placed before it, searching the whole maximum length so the sheet can
// grow into it. Returns canvas coordinates, or undefined when a piece does not fit within
// the maximum length (that piece is not claimed).
export function createRollingSheetSpotFinder(
  spread: Spread | undefined,
  area: Area,
  rollLength: RollLengthBounds,
  gapMm: number,
): (piece: { widthMm: number; heightMm: number }) => RollingSheetSpot | undefined {
  const finder = createFreeSpotFinder(
    { widthMm: area.width, heightMm: rollLength.maxMm },
    getSheetArtworkRects(spread, area),
    gapMm,
  );
  return (piece) => {
    const spot = finder.find(piece);
    if (!spot) {
      return undefined;
    }
    const rect = { xMm: spot.xMm, yMm: spot.yMm, widthMm: piece.widthMm, heightMm: piece.heightMm };
    finder.claim(rect);
    return { x: area.left + spot.xMm, y: area.top + spot.yMm, rect };
  };
}

// Where one new upright piece of artwork goes on a rolling gang sheet.
function findSpotOnRollingSheet(
  spread: Spread | undefined,
  area: Area,
  rollLength: RollLengthBounds,
  piece: { widthMm: number; heightMm: number },
  gapMm: number,
): RollingSheetSpot | undefined {
  return createRollingSheetSpotFinder(spread, area, rollLength, gapMm)(piece);
}

export default findSpotOnRollingSheet;
